<template>
  <div class="aside-container" :class="{ ready: ready }">
    <AsideChapterProgress v-if="chapter" />

    <AsideSubChapters v-if="isSubChapter" @ready="handleSubChaptersReady" />

    <AsideSections v-if="hasChildren" />

    <ExerciseButtonRandomLink v-show="hasRandomExercises" />
  </div>
</template>
<script lang="ts" setup>
const {
  section,
  categoryManager: { category },
  chapter,
} = inject(INJECT_CATEGORY_PAGE);

const ready = ref<boolean>(false);

const profile = useProfileStore();

const { progressions } = inject(INJECT_PROGRESSION_EXERCISES);

const anchorsList = inject(INJECT_ANCHORS, () => useAnchors(ref(0)), true);

const anchors = anchorsList?.anchors;

const hasChildren = computed(() =>
  anchors ? anchors.value.length > 1 : false
);

const progressionsCount = computed(() => {
  return progressions.value.length;
});

const hasRandomExercises = computed(() => {
  if (profile.isParent) {
    return (
      section.value === Sections.ParentForYou && progressionsCount.value > 1
    );
  } else {
    return progressionsCount.value > 1;
  }
});

const isSubChapter = computed(
  () => category.value.contentType === ContentTypes.SubChapter
);

const handleSubChaptersReady = () => {
  ready.value = true;
};

watchEffect(() => {
  if (!isSubChapter.value) ready.value = true;
});
</script>
<style lang="scss" scoped>
.aside-container {
  display: flex;
  flex-direction: column;
  padding: 0 var(--gap_n);
  gap: var(--gap_l);
  @include above('l') {
    padding: 0;
  }

  > * {
    transform: scale(0.95);
    transition: opacity 150ms $ease-out-quad 100ms,
      transform 200ms $ease-out-back 100ms;
    opacity: 0;
  }

  :nth-child(2) {
    transition: opacity 150ms $ease-out-quad 150ms,
      transform 200ms $ease-out-back 150ms;
  }

  &.ready {
    > * {
      transform: scale(1);
      opacity: 1;
    }
  }
}
</style>
